const toLocaleLongDate = (dateString) => {
  if (!dateString) return null;

  let parsedDate;
  const isoDateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateString);
  if (isoDateMatch) {
    const [, year, month, day] = isoDateMatch;
    parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
  } else {
    parsedDate = new Date(dateString);
  }

  if (Number.isNaN(parsedDate.getTime())) return null;

  const locale = window.preferredLanguage
    || (Array.isArray(navigator.languages) && navigator.languages[0])
    || navigator.language
    || 'en-US';

  return new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  }).format(parsedDate);
};

export default toLocaleLongDate;
